import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authAxios, QueryStatus } from "../../utils";
import { RootState } from "../../redux/store";
import { BadgesReturnedApi } from "./badgesApi";

export interface BadgesState {
  badgesReturnedListStatus: QueryStatus;
  badgesReturnedList: BadgesReturnedApi[];
}

const initialState: BadgesState = {
  badgesReturnedListStatus: "idle",
  badgesReturnedList: [],
};

export const badgesReturnedListAsync = createAsyncThunk(
  "badgesReturnedList/call",
  async () => {
    const axios = authAxios();
    const response =
      await axios.get<Array<BadgesReturnedApi>>(`badges/returned`);
    return response.data.sort(
      (a, b) =>
        new Date(b.returnedAt).getTime() - new Date(a.returnedAt).getTime(),
    );
  },
);

export const badgesSlice = createSlice({
  name: "badges",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(badgesReturnedListAsync.pending, (state) => {
        state.badgesReturnedListStatus = "processing";
      })
      .addCase(badgesReturnedListAsync.fulfilled, (state, action) => {
        state.badgesReturnedList = action.payload;
        state.badgesReturnedListStatus = "success";
      })
      .addCase(badgesReturnedListAsync.rejected, (state) => {
        state.badgesReturnedListStatus = "failed";
      });
  },
});

export const selectBadgesReturnedList = (state: RootState) =>
  state.badges.badgesReturnedList;

export const selectBadgesReturnedListStatus = (state: RootState) =>
  state.badges.badgesReturnedListStatus;

export default badgesSlice.reducer;
